import React from "react"; 
const IconView = ({ size = 25 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}><g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.0833" transform="translate(1 2)"><path d="M0 8.3333S4.1667 0 11.4583 0C18.75 0 22.9167 8.3333 22.9167 8.3333s-4.1667 8.3334-11.4584 8.3334C4.1667 16.6667 0 8.3333 0 8.3333z" /><circle cx="11.4583" cy="8.3333" r="3.125" /></g></svg>
); 
export default IconView;
